__turbopack_context__.v({
  "ai-search": "style-module-scss-module__6Mk7vG__ai-search",
  "component": "style-module-scss-module__6Mk7vG__component",
  "extra-right-margin": "style-module-scss-module__6Mk7vG__extra-right-margin",
  "extra-top-margin": "style-module-scss-module__6Mk7vG__extra-top-margin",
  "not-visible": "style-module-scss-module__6Mk7vG__not-visible",
});
